<template>
    <div class="tab-text">
      <section>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Streaming Solution</span>
            <div style="font-size:0.75rem; color:#aaa;"></div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <b-form-select
              v-model="liveForm.live_engine"
              :options="liveEngineList"
            ></b-form-select>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Streaming Solution 2</span>
            <div style="font-size:0.75rem; color:#aaa;">
              Used as a backup, in case the first solution fails
            </div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <b-form-select
              v-model="liveForm.live_engine_2"
              :options="liveEngineList"
            ></b-form-select>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Rerun</span>
            <div style="font-size:0.75rem; color:#aaa;">
              If enabled, the Watch Rerun button will be shown
            </div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <ul class="demo-alignment">
              <li>
                <vs-radio
                  vs-name="rerun_status"
                  v-model="liveForm.rerun_status"
                  :vs-value="1"
                  >Enabled</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  vs-name="rerun_status"
                  v-model="liveForm.rerun_status"
                  :vs-value="0"
                  >Disabled</vs-radio
                >
              </li>
            </ul>
          </div>
        </div>

        <section v-if="liveForm.live_engine == 'zoom'">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Zoom</span>
              <div style="font-size:0.75rem; color:#aaa;"></div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <ul class="demo-alignment">
                <li>
                  <vs-radio
                    vs-name="live-zoom_status"
                    v-model="liveForm.zoom_status"
                    vs-value="1"
                    >Enabled</vs-radio
                  >
                </li>
                <li>
                  <vs-radio
                    vs-name="live-zoom_status"
                    v-model="liveForm.zoom_status"
                    vs-value="0"
                    >Disabled</vs-radio
                  >
                </li>
              </ul>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Zoom Account</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <b-form-select
                v-model="liveForm.zoom_account_no"
                :options="zoomList"
              ></b-form-select>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Webinar ID</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                name="name"
                class="w-full"
                v-model="liveForm.zoom_webinar_id"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Session Format</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <ul class="demo-alignment">
                <li>
                  <vs-radio
                    vs-name="zoom_session_type"
                    v-model="liveForm.zoom_session_type"
                    vs-value="webinar"
                    >Webinar</vs-radio
                  >
                </li>
                <li>
                  <vs-radio
                    vs-name="zoom_session_type"
                    v-model="liveForm.zoom_session_type"
                    vs-value="meeting"
                    >Meeting</vs-radio
                  >
                </li>
              </ul>
            </div>
          </div>
        </section>

        <div class="vx-row mb-6">
          <!-- v-show="false" -->
        <!-- <div class="vx-row mb-6"> -->
          <div class="vx-col sm:w-1/3 w-full">
            <span>Join URL</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="liveForm.join_url" />
          </div>
        </div>


        <template>
          <!-- v-if="false" -->
        <!-- <template v-if="liveForm.live_engine != 'zoom'"> -->
          <!-- <hr /> -->
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Vimeo URL</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                name="name"
                class="w-full"
                v-model="liveForm.vimeo_playback_url"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Dacast URL</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                name="name"
                class="w-full"
                v-model="liveForm.dacast_playback_url"
              />
            </div>
          </div>
          <!-- <div
            class="vx-row mb-6"
            v-if="liveForm.ivs_viewer_endpoint_url == null"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span></span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-button @click="createIVS()" size="small"
                >Create IVS Channel</vs-button
              >
            </div>
          </div> -->
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>IVS Streaming URL</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                name="name"
                class="w-full"
                v-model="liveForm.ivs_creator_endpoint_url"
              />
              <!-- :disabled="liveForm.ivs_viewer_endpoint_url == null" -->
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>IVS Streaming Key</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                name="name"
                class="w-full"
                v-model="liveForm.ivs_creator_stream_key"
              />
              <!-- :disabled="liveForm.ivs_viewer_endpoint_url == null" -->
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>IVS Player URL</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                name="name"
                class="w-full"
                v-model="liveForm.ivs_viewer_endpoint_url"
              />
              <!-- :disabled="liveForm.ivs_viewer_endpoint_url == null" -->
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>IVS Channel ID</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                name="name"
                class="w-full"
                v-model="liveForm.ivs_channel_id"
              />
              <!-- :disabled="liveForm.ivs_viewer_endpoint_url == null" -->
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>IVS Playback URL</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                name="name"
                class="w-full"
                v-model="liveForm.ivs_playback_url"
              />
              <!-- :disabled="liveForm.ivs_viewer_endpoint_url == null" -->
            </div>
          </div>
        </template>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Speaker URL</span>
            <div style="font-size:0.75rem; color:#aaa;">
              Link for the speakers to join
            </div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="basicForm.speaker_url" />
          </div>
        </div>
        <vs-divider></vs-divider>
        <div class="vx-row pt-2 mt-0">
          <div class="vx-col w-full ml-auto">
            <vs-button class="mr-3 mb-2" @click="submitLive">Save </vs-button>

            <vs-button class="mr-3 mb-2" type="border" @click="canceled">Cancel </vs-button>
          </div>
        </div>
      </section>
    </div>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";
import Service from "@/services";

import { currencyList, protypeList } from "@/utils/Constants";
import { timezones } from "@/utils/Timezones";
import { eventFieldsPermission } from "@/utils/FieldsPermission";

import { liveForm, basicForm } from "@/utils/eventForm";

export default {
  components: {},
  props: {
    event: null,
    role: null,
    liveForm: liveForm,
    basicForm: basicForm,
    folder: null
  },
  data() {
    return {
      zoomList: [
        { text: "Account 1", value: "1" },
        { text: "Account 2", value: "2" }
      ],
      liveEngineList: [
        { text: "Zoom", value: "zoom" },
        { text: "AWS IVS", value: "ivs" },
        { text: "Vimeo", value: "vimeo" },
        { text: "Facebook", value: "facebook" },
        { text: "Youtube", value: "youtube" },
        { text: "Dacast", value: "dacast" }
      ]
    };
  },
  methods: {
    submitLive() {
      this.liveForm.e = this.folder;

      this.$vs.loading();

      Service.Event.update({
        ...this.liveForm,
        ...this.basicForm,
        pay_creditcard: (this.event.pay_creditcard === null && this.basicForm.pay_creditcard === 1) ? null: this.basicForm.pay_creditcard ,
        pay_transfer: (this.event.pay_transfer === null && this.basicForm.pay_transfer === 1) ? null: this.basicForm.pay_transfer ,
        fields_status: this.event.fields_status === null ? null: this.basicForm.fields_status
      })
        .then(res => {
          if (res.success) {
            this.$vs.notify({
              title: "Success",
              text: "Update complete.",
              color: "success"
            });
          }
          this.$vs.loading.close();
        })
        .catch(err => {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger"
          });
          this.$vs.loading.close();
        });
    },
    canceled() {
      this.$router.push(`/dash`)
    }
  }
};
</script>
